/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Add smooth scrolling behavior
export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    // Smooth scroll for anchor links
    const handleAnchorClick = e => {
      const href = e.target.getAttribute("href")
      if (href && href.startsWith("#")) {
        const element = document.querySelector(href)
        if (element) {
          e.preventDefault()
          const headerOffset = 100
          const elementPosition = element.getBoundingClientRect().top
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          })
        }
      }
    }

    // Add event listener to all anchor links
    document.addEventListener("click", e => {
      if (
        e.target.tagName === "A" &&
        e.target.getAttribute("href")?.startsWith("#")
      ) {
        handleAnchorClick(e)
      }
    })

    // Remove borders and white backgrounds from syntax highlighter
    const style = document.createElement("style")
    style.textContent = `
      .code-snippet-block pre,
      .code-snippet-block code,
      .code-snippet-block pre code,
      .code-snippet-block pre span,
      .code-snippet-block code span,
      .code-snippet-block div pre,
      .code-snippet-block div code,
      .code-snippet-block div {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        background: #202020 !important;
      }
      .code-snippet-block pre span,
      .code-snippet-block code span {
        background: transparent !important;
      }
      .code-snippet-block pre .linenumber,
      .code-snippet-block pre span[class*="linenumber"],
      .code-snippet-block pre .token.linenumber,
      .code-snippet-block div pre .linenumber,
      .code-snippet-block div pre span[class*="linenumber"],
      .code-snippet-block div pre .token.linenumber {
        color: #888 !important;
        min-width: 3em !important;
        padding-right: 1em !important;
        padding-left: 0 !important;
        margin-left: 0 !important;
        text-align: right !important;
        user-select: none !important;
        display: inline-block !important;
      }
      /* Fix alignment for all line numbers */
      .code-snippet-block pre,
      .code-snippet-block div pre {
        padding-left: 0 !important;
      }
      .code-snippet-block pre code,
      .code-snippet-block div pre code {
        padding-left: 0 !important;
      }
    `
    document.head.appendChild(style)
  }
}
